'use strict';

const linkSelector = '.nav-desktop__link';
const itemSelector = '.nav-desktop__item';
const itemActiveClass = 'nav-desktop__item--active';
const parentActiveClass = 'is-active';
const menuBtnId = 'nav-btn';

(function () {
    const links = document.querySelectorAll(linkSelector);
    const menuBtn = document.getElementById(menuBtnId);

    if (!links.length) {
        return;
    }

    let timeout;

    links.forEach(link => {
        const process = () => {
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(() => {
                link.closest('ul').querySelectorAll(itemSelector).removeClass(itemActiveClass);
                link.closest('li').classList.add(itemActiveClass);

                if (link.nextElementSibling) {
                    link.closest('ul').classList.add(parentActiveClass);
                    link.nextElementSibling.nextElementSibling.classList.remove(parentActiveClass);
                } else {
                    link.closest('ul').classList.remove(parentActiveClass);
                }
            }, 250);
        }

        if (link.nextElementSibling) {
            if (window.getComputedStyle(link.nextElementSibling).display === 'none') {
                link.addEventListener('mouseover', process);
                link.addEventListener('focus', process);
            } else {
                link.nextElementSibling.addEventListener('click', process);
            }
        } else {
            link.addEventListener('mouseover', process);
            link.addEventListener('focus', process);
        }
    });

    if(menuBtn) {
        const resetMenu = () => {
            links.forEach(link => {
                setTimeout(function(){
                    link.closest('ul').querySelectorAll(itemSelector).removeClass(itemActiveClass);
                    link.closest('ul').classList.remove(parentActiveClass);
                }, 500);
            });
        }

        menuBtn.addEventListener('click', resetMenu);
    }
}());
